module.exports = __webpack_public_path__ + "static/media/vanessa-logo.0eb0ba3f.png";